module.exports = __webpack_public_path__ + "media/Final_HD.7e6e825c.mp4";